import React, { FC } from 'react'
import { useScreenClass, Hidden } from 'react-grid-system'
import styled from 'styled-components'
import FACULTY from '../../assets/FacultyPhoto.jpeg'
import SCHEDULE from '../../assets/Classroom.jpg'
import { Button } from '../shared'

const variantOptions = {
  schedule: {
    title: 'Program Schedule',
    headline: 'Launch your podcast—one evening a week.',
    description: (
      <p>
        Our hybrid format fits your busy life: weekly evening workshops
        (Tuesdays at 7 PM ET), both online and in-person in NYC. Over two
        immersive semesters, you’ll conceive, pitch, script, record,
        edit, and polish your show through hands-on assignments and peer
        feedback. Plus, you get 8+ months of one-on-one mentoring to keep
        you on track—so your podcast debuts with confidence and clarity.
      </p>
    ),
  },
  faculty: {
    title: 'Expert Faculty',
    headline: 'Learn from the pioneers of podcasting.',
    description: (
      <p>
        Get coached by the industry’s best: the people behind the scenes of
        <em> Here’s The Thing with Alec Baldwin</em>, <em>Song Exploder</em>,
        <em> You And Me Both with Hillary Clinton</em>, <em>Unconfuse Me with Bill Gates</em> and countless
        indies. Our faculty bring real-world production, storytelling, and
        audience-building expertise—so you gain insider techniques,
        professional rigor, and creative confidence.
      </p>
    ),
  },
}

const SlideText = styled.div<{ isDesktop: boolean }>`
  height: ${(props) => (props.isDesktop ? '500px' : '600px')};
  background-color: ${(props) =>
    props.isDesktop ? '' : 'rgba(239,239,239, 0.70)'};
  width: ${(props) => (props.isDesktop ? '45%' : '100%')};
  padding: 2rem;
  text-align: left;
  margin: ${(props) => (props.isDesktop ? '0 0 0 2rem' : '0')};

  h5 {
    font-size: ${(props) => (props.isDesktop ? '22px' : '20px')};
    margin-top: 0;
  }

  h3 {
    color: ${(props) => props.theme.colors.brightRed};
    font-size: ${(props) => (props.isDesktop ? '30px' : '28px')};
    width: ${(props) => (props.isDesktop ? '80%' : '')};
  }

  p {
    line-height: 1.6rem;
    margin-bottom: 1.75rem;
  }
`
interface Prop {
  variant: 'schedule' | 'faculty'
}

const Slide: FC<Prop> = ({ variant }) => {
  const screenClass = useScreenClass()
  const isDesktop = ['lg', 'xl'].includes(screenClass)

  const title = variantOptions[variant].title
  const headline = variantOptions[variant].headline
  const description = variantOptions[variant].description
  return (
    <>
      <SlideText isDesktop={isDesktop}>
        <h5>{title}</h5>
        <h3>{headline}</h3>
        {description}
        <Button
          variant="red"
          path={variant === 'schedule' ? '/apply' : '/faculty'}
        >
          {variant === 'schedule' ? 'Program Info' : 'Learn More'}
        </Button>
      </SlideText>
      <Hidden xs sm md>
        <img
          src={variant === 'schedule' ? SCHEDULE : FACULTY}
          alt=""
          style={{
            width: '46%',
            height: isDesktop ? '500px' : '600px',
            objectFit: 'cover',
            margin: '0 auto',
            objectPosition: 'top center',
          }}
        />
      </Hidden>
    </>
  )
}

export default Slide
